/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import ic_beenhere_circle from "../../assets/images/pictures/icon/ic_outline-beenhere_circle-64px.svg"
import ic_play_circle from "../../assets/images/pictures/icon/ic_outline-play_circle_filled_white_circle-40px.svg"
import ic_out_line_chat_circle from "../../assets/images/pictures/icon/ic_outline-chat_circle-40px.svg"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const CaseStudiesChildFooter = () => {
    const {t} = useTranslation()



    return (
        <>
            <div className="bg-color bg-color--height"></div>
            <div className="container change-work">
                <div className="row">
                    <div className="col-md-12">
                        <img src={ic_beenhere_circle} alt="" data-no-retina="" />
                        <h2 className='font-weight-bold'>{t('case-studies-child-footer.heading')}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 pl-md-0">
                        <div className="panel">
                            <img src={ic_play_circle} alt="" data-no-retina="" />
                            <h3>{t('case-studies-child-footer.description-1')}</h3>
                            <Link className="btn-secondary" to="/pricing/portal">{t('case-studies-child-footer.button-see-pricing')}</Link>
                        </div>
                    </div>
                    <div className="col-sm-6 pr-md-0">
                        <div className="panel">
                            <img src={ic_out_line_chat_circle} alt="" data-no-retina="" />
                            <h3>{t('case-studies-child-footer.description-2')}</h3>
                            <Link className="btn-secondary" to="/contacts">{t('case-studies-child-footer.button-contact-sales')}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CaseStudiesChildFooter